import React, {useEffect, useState} from 'react'
import {Slider} from '@material-ui/core';
import {Controller, useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {CompanySoftSkillsExample} from '../../components/Cards/Company/SoftSkillsExample';
import Button from '../../components/Common/Button';
import {radarInit, ROUTES, softSkillsDataset} from '../../db/models/const';
import {openDialog} from '../../slices/dialog';
import {selectSelectedRm} from '../../slices/selected';
import {updateRmSoftSkills} from '../../api/company';
import {useTranslation} from 'react-i18next';

export const CompanyRmEditSoftSkills = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const examples = [
        {
            name: t("company_rm_editSS_example1_name"),
            description: t("company_rm_editSS_example1_desc"),
            explanations: [
                // { tag: "", text: ""}
            ],
            softSkills: {
                LEADER: 3.5,
                FOLLOWER: 7.5,
                IMPULSIVE: 7,
                THOUGHTFUL: 8,
                PRAGMATIC: 6.5,
                SOFT: 5,
                HARD: 7,
                VISIONARY: 7.5
            }
        },
        {
            name: t("company_rm_editSS_example2_name"),
            description: t("company_rm_editSS_example2_desc"),
            explanations: [
                // { tag: "", text: ""}
            ],
            softSkills: {
                LEADER: 2,
                FOLLOWER: 8,
                IMPULSIVE: 3.5,
                THOUGHTFUL: 8,
                PRAGMATIC: 8,
                SOFT: 3.5,
                HARD: 8,
                VISIONARY: 6
            }
        },
        {
            name: t("company_rm_editSS_example3_name"),
            description: t("company_rm_editSS_example3_desc"),
            explanations: [
                // { tag: "", text: ""}
            ],
            softSkills: {
                LEADER: 5,
                FOLLOWER: 6.5,
                IMPULSIVE: 7.5,
                THOUGHTFUL: 5,
                PRAGMATIC: 5.5,
                SOFT: 6.5,
                HARD: 6.5,
                VISIONARY: 7
            }
        },
        {
            name: t("company_rm_editSS_example4_name"),
            description: t("company_rm_editSS_example4_desc"),
            explanations: [
                // { tag: "", text: ""}
            ],
            softSkills: {
                LEADER: 1.5,
                FOLLOWER: 8.5,
                IMPULSIVE: 1.5,
                THOUGHTFUL: 9,
                PRAGMATIC: 8.5,
                SOFT: 1.5,
                HARD: 8.5,
                VISIONARY: 3.5
            }
        },
    ];
    const rm = useSelector(selectSelectedRm);
    const history = useHistory();
    const softSkills = rm?.softSkills || radarInit;
    const {register, handleSubmit, errors, control, getValues} = useForm({
        defaultValues: {
            softSkills: {
                LEADER: softSkills.LEADER,
                VISIONARY: softSkills.VISIONARY,
                THOUGHTFUL: softSkills.THOUGHTFUL,
                SOFT: softSkills.SOFT,
                FOLLOWER: softSkills.FOLLOWER,
                PRAGMATIC: softSkills.PRAGMATIC,
                IMPULSIVE: softSkills.IMPULSIVE,
                HARD: softSkills.HARD
            },
            softSkillsExplanation: rm?.softSkillsExplanation || ""
        }
    });
    const [max, setMax] = useState();
    const [sum, setSum] = useState(Object.values(softSkills).reduce((a, b) => a + b, 0));

    useEffect(() => {
        if (!rm) {
            history.push(ROUTES.ME);
            return;
        }
    }, [rm]);

    useEffect(() => {
        setMax(50);
    }, [])

    const onValueChange = () => {
        const form = getValues();
        const newSum = Object.values(form.softSkills).reduce((a, b) => a + b, 0);
        setSum(newSum);
    }

    const onSave = (form) => {
        if (sum > max) return;

        updateRmSoftSkills(rm.id, form).then(() => {
            history.push(ROUTES.COMPANY_RM);
        });
    }

    const onOpenExample = (example) => {
        dispatch(openDialog({
            title: t("company_rm_editSS_example_title"),
            Content: CompanySoftSkillsExample,
            props: {example},
            closable: true
        }))
    };

    return (
        <div className="companyRmEditSoftSkills card">
            <div className="title">{t("company_rm_editSS_title")}</div>
            <p className="desc">{t("company_rm_editSS_expl")}</p>
            <label>{t("company_rm_editSS_examples_label")}</label>
            <div className="examples">
                {examples.map(ex => <Button filled={true} onClick={() => onOpenExample(ex)}>{ex.name}</Button>)}
            </div>

            <label className="counters">
                {t("company_rm_editSS_points_label") + "   "}
                <span className={sum > max ? "error" : ""}>{t("company_rm_editSS_points_values", {
                    partial: sum,
                    total: max
                })}</span>
            </label>

            <form onSubmit={handleSubmit(onSave)}>
                {Object.keys(softSkillsDataset).map(tag => (
                    <div className="element">
                        <label>{t(softSkillsDataset[tag].label)}</label>
                        <p className="pre-wrap">{t(softSkillsDataset[tag].description)}</p>
                        <Controller
                            name={`softSkills.${tag}`}
                            onChange={(_, data) => data}
                            control={control}
                            rules={{required: true, min: 1}}
                            render={(props) => (
                                <Slider
                                    {...props}
                                    onChange={(_, value) => {
                                        props.onChange(value);
                                        onValueChange(value);
                                    }}
                                    marks={true}
                                    valueLabelDisplay="auto"
                                    min={1}
                                    max={10}
                                    step={1}
                                />
                            )}
                        />
                        {errors[tag] && <span className="error">{t("form_generic_required")}</span>}
                    </div>
                ))}
                <div className="softSkillsExplanation">
                    <label>{t("company_rm_editSS_desc_label")}</label>
                    <p>{t("company_rm_editSS_desc_expl")}</p>
                    <textarea
                        type="text"
                        name="softSkillsExplanation"
                        ref={register()}
                        placeholder={t("company_rm_editSS_desc_ph")}
                        rows="6"
                    />
                </div>
                <input type="submit" disabled={sum > max} value={t("company_rm_editSS_submit")}/>
            </form>
        </div>
    )
}
